/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Jay's Portfolio",
  description:
    "Experienced Java and Spring Boot developer with two years of hands-on experience in designing, developing, and deploying robust, scalable, and efficient web applications. Proficient in Java programming language and adept at leveraging Spring Boot framework to rapidly develop backend services and RESTful APIs. Experienced in database management systems including SQL and NoSQL databases.",
  og: {
    title: "Jay Gohil Portfolio",
    type: "website",
    // url: "http://ashutoshhathidara.com/",
  },
};

//Home Page
const greeting = {
  title: "Jay Gohil",
  logo_name: "Jay Gohil",
  nickname: "Java Full Stack Developer",
  subTitle:
    "Experienced Java and Spring Boot developer with two years of hands-on experience in designing, developing, and deploying robust, scalable, and efficient web applications. Proficient in Java programming language and adept at leveraging Spring Boot framework to rapidly develop backend services and RESTful APIs. Experienced in database management systems including SQL and NoSQL databases.",
  resumeLink:
    "https://drive.google.com/file/d/1JxrCYDlGlCu-dHUdTds2C1sDTTSGKtec/view?usp=sharing",
  // portfolio_repository: "https://github.com/ashutosh1919/masterPortfolio",
  githubProfile: "https://github.com/codingcreativity",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  {
    name: "Github",
    link: "https://github.com/codingcreativity",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/jay-gohil1/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:gohiljay0882430@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "X-Twitter",
    link: "https://twitter.com/Gohiljay088",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/profile.php?id=100005986665759",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/jay_gohil11/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Developed and maintained web applications using Java, Spring Boot, Hibernate and PostgreSQL, ensuring optimal performance and responsiveness.",
        "⚡ Implemented RESTful web services to facilitate data exchange between the server and client application.",
        "⚡ Developed responsive UI using angular 14+ or React",
      ],
      softwareSkills: [
        {
          skillName: "Java",
          fontAwesomeClassname: "logos:java",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "Spring",
          fontAwesomeClassname: "devicon:spring",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Spring Boot",
          fontAwesomeClassname: "simple-icons:springboot",
          style: {
            color: "#6DB33F",
          },
        },
        {
          skillName: "Angular",
          fontAwesomeClassname: "simple-icons:angular",
          style: {
            // backgroundColor: "#000000",
            color: "#DD1100",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ PostgreSQL and mongodb databases used for performing data related operations",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        // {
        //   skillName: "Firebase",
        //   fontAwesomeClassname: "simple-icons:firebase",
        //   style: {
        //     color: "#FFCA28",
        //   },
        // },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Jenkins",
          fontAwesomeClassname: "devicon:jenkins",
          style: {
            color: "#1488C6",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Google Cloud",
      iconifyClassname: "devicon:googlecloud",
      style: {
        color: "#F79F1B",
      },
      profileLink:
        "https://www.cloudskillsboost.google/public_profiles/f0bd1874-22a0-4534-8efc-1c211d988c77",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/profile/gohiljay5255",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Saurashtra University, Rajkot",
      subtitle: "Bachelor Of Computer Application - BCA",
      logo_path: "sau_logo.png",
      alt_name: "saurashtra university",
      duration: "2019 - 2022",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Java, DBMS, OS, C, C++, Python, ASP.NET etc.",
        "⚡ Apart from this, I have participated in google cloud ready facilitator programme 2022 as a facilitator.",
        "⚡ I have done 2 projects in my bachelors. First project is based on freelancing platform created using php. And second project is based on library management system created using asp.net.",
      ],
      website_link: "https://www.saurashtrauniversity.edu/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Debutant Exceptional",
      subtitle: "- Paramatrix Technologies",
      logo_path: "paramatrix-logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1jEg9aFZUvIYrTKwh7K806OaRQNoPKh2U/view?usp=sharing",
      alt_name: "Paramatrix Technologies Pvt Ltd.",
      color_code: "#4285F499",
    },

    {
      title: "Java",
      subtitle: "- HackerRank",
      logo_path: "java-logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1yPsaKmD3fQXgsn9If0ZKE34j2Hs6iFey/view?usp=sharing",
      alt_name: "java",
      color_code: "#4285F499",
    },
    {
      title: "Java Programming",
      subtitle: "- Great Learning",
      logo_path: "java-logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1xOQtkxSd1KuyyOND6C4184I0D04uRLRa/view?usp=sharing",
      alt_name: "java-programming",
      color_code: "#4285F499",
    },
    {
      title: "Google Cloud",
      subtitle: "- GCRF Program",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1PXdo8appxYnOuZaBgrQYtpgeua-Lqbo6/view?usp=sharing",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Cloud Skill Boost",
      subtitle: "- Skill Badges",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://www.cloudskillsboost.google/public_profiles/f0bd1874-22a0-4534-8efc-1c211d988c77",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "SQL",
      subtitle: "- HackerRank",
      logo_path: "sql_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1yDxEs5nXeT9BO2Yp03o0cDkKCZ2Z9Hkn/view?usp=sharing",
      alt_name: "SQL",
      color_code: "#4285F499",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work",
  description:
    "Specializing in Java and Spring Boot, my career journey has been dedicated to crafting robust and scalable backend solutions. With a deep understanding of Java's fundamentals and Spring Boot's framework, I've delivered efficient and maintainable codebases, ensuring optimal performance and reliability. My expertise includes designing and implementing RESTful APIs, integrating various third-party services, and optimizing database interactions for enhanced application responsiveness.  ",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Software Programmer",
          company: "Paramatrix Technologies Ltd.",
          company_url: "https://paramatrix.com/",
          logo_path: "ptpl-logo.png",
          duration: "July 2024 - Present",
          location: "Ahmedabad, Gujarat",
          description:
            "This role marked a significant step in my career, allowing me to take on more complex challenges and leadership responsibilities. In this position, I have been instrumental in driving innovation and ensuring the successful delivery of high-quality software solutions.",
          color: "#0879bf",
        },
        {
          title: "Associate Software Programmer",
          company: "Paramatrix Technologies Ltd.",
          company_url: "https://paramatrix.com/",
          logo_path: "ptpl-logo.png",
          duration: "July 2022 - June 2024",
          location: "Ahmedabad, Gujarat",
          description:
            "I am working on several technologies like Java, Spring Boot, Spring Security, Hibernate and Angular. I have learnt lots of things from this organization. I worked on many project like IDP (Investment Declaration Portal), PACE (Paramatrix Applications Core Engine), EPPM (Enterprise Programe and Project Management) or SPS (Shipment Processing Service).",
          color: "#0879bf",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. I have worked on projects that used technologies like Spring Boot, Angular, PostgreSQL etc. I have learned lot's of things related to latest technologies from these projects.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "neuro-symbolic-sudoku-solver",
      name: "Neuro-Symbolic Sudoku Solver",
      createdAt: "2023-07-02T00:00:00Z",
      description: "Paper published in KDD KiML 2023",
      url: "https://arxiv.org/abs/2307.00653",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "animated_ashutosh.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with Java, Spring Boot, React, Angular, Cloud and Opensource Development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "https://blogs.ashutoshhathidara.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Saratoga Ave, San Jose, CA, USA 95129",
    locality: "San Jose",
    country: "USA",
    region: "California",
    postalCode: "95129",
    streetAddress: "Saratoga Avenue",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/NvYZqa34Wye4tpS17",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
